import React from 'react';
import {observer} from 'mobx-react';
import {JoinRequestBanner} from '@techsee/techsee-nway-media-service-client/lib/components/JoinRequestBanner/JoinRequestBanner';
import {MultipartyDashboardController} from '../../MultipartyDashboardController';

type NwayJoinRequestBannerProps = {
    controller: MultipartyDashboardController;
    className: string;
    children?: React.ReactNode;
};

export const NwayJoinRequestBanner = observer(function NwayJoinRequestBanner({
    controller,
    className,
    children
}: NwayJoinRequestBannerProps) {
    if (controller.isParticipant) {
        return null;
    }

    return (
        <div className={className}>
            {controller.pendingParticipants.length > 0 && (
                <JoinRequestBanner
                    pendingParticipants={controller.pendingParticipants}
                    titleLabel={controller.translate('REACT.NWAY.JOIN_REQUEST_TITLE')}
                    bannerTemplate={controller.translate('REACT.NWAY.JOIN_REQUEST_BANNER')}
                    admitLabel={controller.translate('REACT.NWAY.JOIN_REQUEST_ADMIT')}
                    rejectLabel={controller.translate('REACT.NWAY.JOIN_REQUEST_REJECT')}
                    onAdmit={controller.admitParticipant}
                    onReject={controller.rejectParticipant}
                />
            )}
            {children}
        </div>
    );
});
